var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C17.9702 31.0024 19.9214 30.6155 21.7416 29.8616C23.5618 29.1076 25.2151 28.0014 26.6065 26.6065C28.0014 25.2151 29.1076 23.5618 29.8616 21.7416C30.6155 19.9214 31.0024 17.9702 31 16C31.0024 14.0298 30.6155 12.0786 29.8616 10.2584C29.1076 8.43817 28.0014 6.78489 26.6065 5.39351C25.2151 3.99863 23.5618 2.89242 21.7416 2.13845C19.9214 1.38447 17.9702 0.997582 16 1.00001C14.0298 0.997582 12.0786 1.38447 10.2584 2.13845C8.43817 2.89242 6.78489 3.99863 5.39351 5.39351C3.99863 6.78489 2.89242 8.43817 2.13845 10.2584C1.38447 12.0786 0.997582 14.0298 1.00001 16C0.997582 17.9702 1.38447 19.9214 2.13845 21.7416C2.89242 23.5618 3.99863 25.2151 5.39351 26.6065C6.78489 28.0014 8.43817 29.1076 10.2584 29.8616C12.0786 30.6155 14.0298 31.0024 16 31Z",
    stroke: "#E4002B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25.751C16.4973 25.751 16.9742 25.5534 17.3258 25.2018C17.6775 24.8502 17.875 24.3733 17.875 23.876C17.875 23.3787 17.6775 22.9018 17.3258 22.5501C16.9742 22.1985 16.4973 22.001 16 22.001C15.5027 22.001 15.0258 22.1985 14.6742 22.5501C14.3225 22.9018 14.125 23.3787 14.125 23.876C14.125 24.3733 14.3225 24.8502 14.6742 25.2018C15.0258 25.5534 15.5027 25.751 16 25.751Z",
    fill: "#E4002B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.00098V19.001",
    stroke: "#E4002B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.049c34bfc49b62e3d49491e2bd9dcd7e.svg";
export { ForwardRef as ReactComponent };